(() => {
  if (window.MayhemPrivacyFooter) return;
  window.MayhemPrivacyFooter = true;
  const available = () => typeof window.privacyBanner?.showPreferences === 'function';
  const update = () => document.querySelectorAll('[data-mayhem-cookie-preferences]').forEach(button => {
    button.hidden = !available();
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-mayhem-cookie-preferences]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-mayhem-cookie-status]');
    if (status) status.hidden = true;
    button.disabled = true;
    try {
      if (!available()) throw new Error('Privacy preferences unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      if (status) status.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  document.addEventListener('load', event => {
    if (event.target.tagName === 'SCRIPT') update();
  }, true);
  document.addEventListener('visitorConsentCollected', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('load', update);
  update();
})();
